import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import * as AppActions from "../../actions";
import Header from "../../components/Header";
import { Loader } from "semantic-ui-react";
import ReactModal from "react-modal";
import { Document, Page } from "react-pdf";
import InfiniteScroll from "react-infinite-scroller";
import SentListItem from "../../components/SentListItem";
import _ from "lodash";
const uuidv4 = require("uuid/v1");

var width = window.innerWidth - 40;

const customStylesPreview = {
  content: {
    width: "100%",
    height: "100%",
    top: "0px",
    padding: "0px",
    borderRadius: "0px",
    left: "0px",
    backgroundColor: "#e6e6e6",
    border: "0px"
  }
};

class SentItemsContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      lastRefresh: Date(Date.now()).toString(),
      sentItems: [],
      current_page: 1,
      fromDate: "1900-01-01",
      user_id: "",
      form_id: "",
      numPages: 1,
      modalVisible: false,
      toDate: "2200-01-01",
      height: 182,
      hasMore: true
    };
    this.loading = false;
    this.tablet = window.innerWidth - 40 < 650 ? false : true;
    this.refreshScreen = this.refreshScreen.bind(this);
  }

  componentDidMount() {}
  componentWillUnmount() {}

  handleBack() {
    return true;
  }

  resetDate() {
    this.setState({ fromDate: "1900-01-01", toDate: "2200-01-01" });
  }
  refreshScreen() {
    if (this.props.isConnected) {
      this.setState({ lastRefresh: Date(Date.now()).toString() });
    }
  }

  handleClosePreview() {
    this.setModalVisible(false);
    this.setState({ numPages: 0 });
    this.props.actions.updatePreview_go("");
    this.props.actions.updateReport("", "", "", -1, "", "");
  }

  setModalVisible(visible) {
    this.setState({ modalVisible: visible });
  }

  shouldComponentUpdate(nextProps, nextState) {
    const different =
      this.props.sentItems !== nextProps.sentItems ||
      this.props.isConnected !== nextProps.isConnected ||
      this.props.report !== nextProps.report ||
      this.state.modalVisible !== nextState.modalVisible ||
      this.state.hasMore !== nextState.hasMore ||
      this.state.numPages !== nextState.numPages ||
      this.state.toDate !== nextState.toDate ||
      this.state.fromDate !== nextState.fromDate ||
      this.state.sentItems !== nextState.sentItems ||
      this.props.refresh !== nextProps.refresh ||
      this.props.filter !== nextProps.filter;
    if (this.state.lastRefresh !== nextState.lastRefresh) {
      const { actions, sessionId, deviceId, sentItems } = this.props;

      actions.getSentItems(1);
    }

    if (different && this.props.sentItems !== nextProps.sentItems) {
      if (nextProps.sentItems.length > 0) {
        if (this.state.current_page === 1) {
          this.setState({
            current_page: this.state.current_page + 1,
            hasMore: nextProps.sentItems.length < 20 ? false : true,
            sentItems: nextProps.sentItems
          });
        } else {
          this.setState({
            current_page: this.state.current_page + 1,
            sentItems: [...this.state.sentItems, ...nextProps.sentItems]
          });
        }
      } else {
        this.setState({ hasMore: false });
      }
    } else {
      if (nextProps.sentItems.length === 0 && !this.props.isConnected) {
        this.props.actions.getSentItems(1);
      } else {
        if (!this.props.isConnected) {
          this.props.actions.getSentItems(1);
          this.setState({ current_page: 1 });
        }
      }
    }

    return different;
  }

  handleReport(
    result_id,
    form_title,
    form_version,
    date_added,
    form_id,
    icon_path
  ) {
    this.props.actions.resetSentItems();
    this.setModalVisible(true);
    this.props.actions.getFormReport(
      result_id,
      form_title,
      form_version,
      date_added,
      form_id,
      icon_path
    );
  }

  componentWillMount() {
    const { actions, sessionId, deviceId, sentItems, refresh } = this.props;

    actions.getSentItems(1);
 
  }

  handleSearch(from_date, to_date, user_id, form_id) {
    if (this.props.isConnected) {
      this.props.actions.resetSentItems();
      this.props.actions.getSentItems(1, from_date, to_date, user_id, form_id);
      this.setState({
        fromDate: from_date,
        toDate: to_date,
        user_id: user_id,
        form_id: form_id,
        current_page: 1,
        hasMore: true,
        sentItems: []
      });
    }
  }

  componentWillReceiveProps(newProps) {
    if (this.props.report !== newProps.report && !this.state.modalVisible) {
      this.setModalVisible(true);
    } else {
      if (
        this.props.isLoading !== newProps.isLoading &&
        !newProps.isLoading &&
        this.state.modalVisible
      ) {
        this.setModalVisible(false);

        let form_id = this.props.report_form_id;
        let currentForm = _.filter(this.props.forms, function(data) {
          return Number(data.form_id) === Number(form_id);
        });

        let icon_path = "";
        let approval_enabled = false;
        if (currentForm.length > 0) {
          icon_path = currentForm[0].icon_path;
          approval_enabled = currentForm[0].approval_enabled;
        }
        this.handleClick(
          this.props.report_form_id,
          this.props.report_title,
          icon_path,
          this.props.report_version,
          approval_enabled
        );

      }
    }
  }

  handleCopySent(result_id, title, form_id, form_version, date_added) {
    this.props.actions.resetCopy();
    this.props.actions.readSentItemData(
      result_id,
      title,
      form_id,
      form_version,
      date_added
    );

  }

  showLoading(message) {
    return (
      <div>
        <form className="ui form">
          <br />
          <br />
          <br />
          <br />
          <br />
          <Loader active size="large" inline="centered">
            {message}
          </Loader>
        </form>
      </div>
    );
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages: numPages });
  };

  renderModal() {

    if (this.state.modalVisible) {
      return (
        <ReactModal
          isOpen={this.state.modalVisible}
          style={customStylesPreview}
          contentLabel="Example Modal"
          onRequestClose={() => {
            //alert('Modal has been closed.');
          }}
        >
          <Header
            onCopySent={this.handleCopySent.bind(this)}
            storeColour={this.props.storeColour}
            onCloseModal={this.handleClosePreview.bind(this)}
            modal={true}
            preview={true}
            onBack={this.handleBack.bind(this)}
            backLink={"/forms"}
            result_id={this.props.result_id}
            formId={this.props.report_form_id}
            dateAdded={this.props.report_date_added}
            formTitle={this.props.report_title}
            formVersion={this.props.report_version}
          ></Header>
          <Document
            loading={this.showLoading("Loading")}
            noData={this.showLoading("Loading")}
            onLoadSuccess={this.onDocumentLoadSuccess}
            file={this.props.report}
          >
            {_.range(1, this.state.numPages + 1, 1).map(page => (
              <Page pageNumber={page} width={window.outerWidth} />
            ))}
          </Document>
        </ReactModal>
      );
    }

    return null;
  }
  handleClick(form_id, form_title, icon_path, form_version, approval_enabled) {
    var form = _.filter(this.props.actionQueue, {
      draftName: "",
      test: this.props.test
    });

    this.props.actions.updateFormExists(true);
    this.props.actions.updateFormTitle(
      form_title,
      form_version,
      icon_path,
      form_id,
      "",
      approval_enabled
    );
    let recovered = false;
    this.props.actions.setWorkingDraft(form[0].draft, "");
    let uuid = uuidv4();

    this.props.actions.resetSentItems();
    this.props.history.push(
      `/form/${form_id}/${"!" +
        uuid}/false/${recovered}/${form_title}/${form_version}/copy/0/${false}`
    );
  }

  handleFilter(value) {
    this.props.actions.filterJobs(value);
  }

  getForms() {
    var sentItemsArray = [];

    let width = this.width < 450 ? 135 : 151;

    let inDrafts = [];

    this.state.sentItems.forEach((form, index) => {
      sentItemsArray.push(
        <div
          className="listcontainer"
          style={{
            flex: 1,
            width: "600px",
            borderRadius: 4,
            marginBottom: 30,
            backgroundColor: "white",
            borderWidth: 2,
            flexDirection: "row"
          }}
          key={"v" + index}
        >
          <SentListItem
            forms={this.props.forms}
            storeColour={this.props.storeColour}
            width={width}
            container="Jobs"
            onClick={this.handleReport.bind(this)}
            {...form}
            key={index}
          />
        </div>
      );
    });

    if (
      (this.state.hasMore || this.state.current_page === 1) &&
      this.props.total !== -1
    ) {
      sentItemsArray.push(
        <div className="formSectionContainer">
          <form className="ui form">
            <Loader active size="large" inline="centered">
              Loading
            </Loader>
          </form>
        </div>
      );
    }

    return <div style={{ textAlign: "left" }}>{sentItemsArray}</div>;
  }

  getListOfSentItems = () => {
    if (this.loading || !this.state.hasMore) {
      return;
    }
    this.props.actions.getSentItems(
      this.state.current_page,
      this.state.fromDate,
      this.state.toDate,
      this.state.user_id,
      this.state.form_id
    );
  };

  isCloseToBottom({ layoutMeasurement, contentOffset, contentSize }) {
    let y =
      layoutMeasurement.height + contentOffset.y >= contentSize.height - 800;
    return y;
  }

  render() {
    let y = this.state.height - 50 + "px";

    if (this.props.isConnected) {
      return (
        <div>
          {this.renderModal()}
          <Header
            onSearch={this.handleSearch.bind(this)}
            storeColour={this.props.storeColour}
            filter={this.props.filter}
            onFilter={this.handleFilter.bind(this)}
            onRefresh={this.refreshScreen}
            setSidebarVisibility={this.props.actions.setSidebarVisibility}
            formTitle={"Sent"}
          ></Header>
          <div
            className="formsBackground"
            style={{
              height: window.innerHeight,
              paddingBottom: "142px",
              overflowY: "scroll",
              "-webkit-overflow-scrolling": "touch"
            }}
          >
            <InfiniteScroll
              useWindow={false}
              initialLoad={false}
              threshold={0}
              pageStart={0}
              loadMore={this.getListOfSentItems.bind(this)}
              hasMore={true}
            >
              <div
                style={{ textAlign: "center" }}
                className="formSectionContainerX"
              >
                <form
                  className="ui formList"
                  style={{ display: "inline-block", padding: "30px" }}
                >
                  {this.getForms()}
                </form>
              </div>
            </InfiniteScroll>
          </div>
        </div>
      );
    } else {
      return (
        <div
          forceInset={{ top: "always" }}
          style={{
            flex: 1,
            backgroundColor: this.props.storeColour.mainBgColor
          }}
        >
          <Header
            onSearch={this.handleSearch.bind(this)}
            storeColour={this.props.storeColour}
            filter={this.props.filter}
            onFilter={this.handleFilter.bind(this)}
            onRefresh={this.refreshScreen}
            setSidebarVisibility={this.props.actions.setSidebarVisibility}
            formTitle={"Sent"}
          ></Header>
          <div
            style={{
              flex: 1,
              textAlign: "center",
              paddingTop: 30,
              alignItems: "center"
            }}
          >
            <span style={{ marginTop: 30, color: "grey", fontSize: 14 }}>
              Offline: Connect online to see your sent items
            </span>
          </div>
        </div>
      );
    }
  }
}

SentItemsContainer.propTypes = {
  sidebarVisibility: PropTypes.bool.isRequired,
  sessionId: PropTypes.string.isRequired,
  jobs: PropTypes.array.isRequired,
  filter: PropTypes.string.isRequired,
  actions: PropTypes.object.isRequired
};

const mapStateToProps = state => ({
  sidebarVisibility: state.informedWebApp.sidebarVisibility,
  sessionId: state.informedWebApp.sessionId,
  deviceId: state.informedWebApp.deviceId,
  isLoading: state.informedWebApp.isLoading,
  isConnected: state.informedWebApp.isConnected,
  storeColour: state.informedWebApp.storeColour,
  forms: state.forms.data,
  sentItems: state.sentItems.data,
  report: state.sentItems.report,
  report_title: state.sentItems.report_title,
  report_version: state.sentItems.report_version,
  result_id: state.sentItems.result_id,
  report_date_added: state.sentItems.report_date_added,
  report_form_id: state.sentItems.report_form_id,
  total: state.sentItems.total,
  test:
    state.informedWebApp.api === "https://www.in-formed.co.uk/api.php"
      ? false
      : true,
  actionQueue: state.informedWebApp.actionQueue
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(AppActions, dispatch)
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SentItemsContainer);



// WEBPACK FOOTER //
// ./src/containers/SentItemsContainer/index.js